// @ngInject
export function repeatDoneDirective($timeout: ng.ITimeoutService): ng.IDirective {
  return {
    restrict: "A",
    link: function (scope: any, element: ng.IAugmentedJQuery, attrs: any) {
      if (scope.$last) {
        $timeout(() => {
          scope.$eval(attrs.repeatDone);
        });
      }
    }
  };
}
